import getStore from '../store/store';
import Folder from '../store/schema/Folder';
import { ObservableMap } from 'mobx';

export default function getFolderTable(): ObservableMap<string, Folder> {
    return getStore().folderTable;
}
